<template lang="pug">
md-layout(md-column='', md-align='start')
    md-theme(md-name='brown-white')
        // Title
        breadcrumbs(section='Reporting', :nav='nav')

    md-theme(md-name='blue')
        // Reports List
        billing-table
</template>

<script>
import { mapState } from 'vuex';
import BillingTable from '../../shared-components/report/NewBilling.vue';
import Breadcrumbs from '../../shared-components/Breadcrumbs';

export default {
    components: {
        BillingTable,
        Breadcrumbs
    },
    computed: {
        ...mapState({
            useraccount: state => state.user.useraccount,
            siteuser: state => state.user.siteuser
        }),
        nav() {
            return [
                { title: 'New Billing' }
            ]
        }

    }
};
</script>

<style lang="scss">
.on-left {
    margin-top: -5px;
    margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/spa/reporting/NewBilling.vue